<template>
    <div>
        <b-modal id="reservedBookInfo" :title="'Інформація про бронювання'" size="size" footer-class="reader-footer" content-class="reader-content">
            <template v-slot:default>
                <div class="row" v-if="book.description.id">
                    <div class="text-center col-4">
                        <div class="cover book">
                            <div class="book-cover" style="height: 90%; overflow: hidden">
                              <img :src="book.description.scan_book ? '/uploads/'+book.description.scan_book : '/images/cover-default.png'" alt="" style="width: 100%">
                            </div>
                            <div class="m-t-10">
                                ISBN <span v-for="isbn in book.description.isbn">{{ isbn.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-4" >
                        <h1>{{ book.description.title }}
                          <span style="font-size: 18px" v-if="book.description.type_record && book.description.type_record.id == 2 && book.description.number_name">({{ book.description.number_name }})</span>
                          <span style="font-size: 18px" v-else-if="book.description.type_record && (book.description.type_record.id == 3 || book.description.type_record.id == 4) && book.description.name_parts">({{ book.description.name_parts }})</span>
                          <span style="font-size: 18px" v-if="book.description.publication_name">
                            <br>
                          <br>{{ book.description.publication_name.name }}</span>
                        </h1>
                        <span v-if="book.description.author">{{ book.description.author.name }}</span>
                        <br>
                        <div>
                            <i v-for="n in 3" class="mdi mdi-star star"></i><i class="mdi mdi-star-half star"></i><i class="mdi mdi-star-outline star"></i>
                        </div>
                        <div class="m-t-20">
                            <span class="table-show-reader">Видавництво:</span>
                            <hr style="margin-top: 0">
                            <div class="row">
                                <div class="col-10">
                                    <span style="font-size: 14px" v-if="book.description.publication && book.description.publication.name">{{ book.description.publication.name }}, {{ book.description.year }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-20">

                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="cover reader-avatar-show" v-if="book.reader"> <!-- КОСТЫЛЬ -->
                            <div class="d-flex p-20 p-b-0" style="cursor: pointer;" @click="getModal">
                                <div class="col-6 text-center p-r-10 d-flex justify-content-center">
                                    <div class="avatar" :style="book.reader.photo ? 'background-image:url(/uploads/'+book.reader.photo+')' : 'background-image:url(/images/avatar.png)'"></div>
                                </div>
                                <div class="col-6 m-auto p-l-0">{{ book.reader.fullname }}</div>
                            </div>
                          <div class="p-l-20 p-b-0">
                            <div class="col-6">
                              <div class="m-t-10">
                                <i v-for="n in 3" class="mdi mdi-star star-reader"></i><i class="mdi mdi-star-half star-reader"></i><i class="mdi mdi-star-outline star-reader"></i>
                              </div>
                            </div>
                          </div>

                            <hr class="m-l-20 m-r-20">
                            <div class="row p-20 p-b-0 p-t-0">
                                <div class="col-6 text-left">
                                    <span>Дата бронювання:</span>
                                </div>
                                <div class="col-6 text-right text-nowrap">
                                    <span class="date">{{ moment(book.created_at).format("YYYY-MM-DD hh:mm:ss") }}</span>
                                </div>
                            </div>
                            <div class="row p-l-20 p-r-20">
                                <div class="col-6 text-left">
                                    <span>Дійсне до:</span>
                                </div>
                                <div class="col-6 text-right">
                                    <span class="date">{{ moment(book.ended_at).format("YYYY-MM-DD hh:mm:ss") }}</span>
                                </div>
                            </div>
                            <div class="row p-l-20 p-r-20">
                                <div class="col-12">

                                </div>
                            </div>
                        </div>
                      <div v-else class="cover reader-avatar-show">

                      </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <p>Нічого не знайдено</p>
                </div>
            </template>

            <template v-slot:modal-footer>
                <div class="row w-100 text-center" v-if="book.description.hasOwnProperty('id')">
                    <div class="col-4">
                        <a :href="'/library/description/' + book.description.id" class="btn btn-outline-secondary m-auto" style="padding:18px">
                            Детальніше...
                        </a>
                    </div>
                    <div class="col-4">
                        <b-input-group v-if="book.reader.allow_get_book == 1">
                            <template v-slot:append>
                                <b-input-group-text class="button-index">
                                    <img src="/theme/icons/plus-multiple.svg">
                                </b-input-group-text>
                            </template>
                            <b-form-input type="search" class="input-index" placeholder="Додати книжку за номером" @change="giveBook($event, book.reader.id, book.description.id);"></b-form-input>
                        </b-input-group>
                    </div>
                    <div class="col-4" v-if="book.id">
                        <button class="btn btn-danger" @click="$root.deleteReservedBook(book.id);$bvModal.hide('reservedBookInfo');">
                            Видалити бронювання
                        </button>
                    </div>
                </div>
                <div class="row w-100 m-b-20 text-center" style="height:10px">
                    <div class="invalid-feedback">

                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "ReservedBookInfo",
        props:['book'],
        mounted() {
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
              if(modalId === 'bookInfo'){
                this.$root.$data.searchresults = {
                  reader: {
                    fullname: null,
                    address: null,
                    code: null,
                  },
                  booksearched: {
                    id: null,
                    code: null,
                    status_id: null,
                    description: {
                      title: null,
                      author: null,
                      publication: null
                    },
                  reservedbook: {
                      id: null,
                      title: null,
                  },
                  }
                }
              }
            })
        },
      methods:{
          giveBook(event, reader_id, decription_id){
              this.$root.giveBook(event, reader_id, decription_id);
              $('.input-index').val('');
          },
          prolongBook(id){
            axios.get('/library/prolong/'+id).then(()=>{
              this.$emit("back_book");
              this.$bvModal.hide('bookInfo');
              this.$root.searchInLibrary(this.book.code)
              this.$root.$refs.events.getStories(true);
            });
          },
          getModal(book){
            this.$bvModal.hide('bookInfo');
            if(this.$route.path === '/library' || this.$route.path === '/library/stories'){
              this.$root.searchInLibrary(this.book.reader.code)
            }
          },
          moment: function (date) {
            return moment(date);
          },
      }
    }

</script>

<style>
    .reader-content {
      border-radius: 16px;
    }
</style>

<style scoped>
    .avatar{
        width: 80px;
        height: 80px;
        background-size: cover;
        background-position: top center;
        border-radius: 50%;
        border: 3px solid #A7AFBA;
    }
    .cover{
        background-color: #F8F8F8;
        border-radius: 8px;
        width: 100%;
        height: 100%;
    }
    h1{
        font-size: 18px;
    }
    span{
        font-size: 13px;
    }
    .star-reader{
        color: #A7AFBA;
        font-size: 15px;
    }
    .star {
        color:#FFD384;
        font-size: 24px;
    }
    .input-index{
        height: 60px;
    }
    .button-index{
        height: 60px;
    }
    .btn-danger{
        height: 60px;
        width: 100%;
        border-radius: 8px;
    }
    .reader-avatar-show{
      font-size: 14px;
    }
    .reader-avatar-show span{
        font-size: 10px;
        color: #A7AFBA;
    }
    .reader-avatar-show .date{
        color: #414141;
    }
    .btn-debtor{
        width: 100%;
    }
</style>